<template>
  <section class="form-section">
    <div class="form-section__head">
      <h3>판매신청 제품</h3>
    </div>
    <div>
      <figure class="form-list__phone">
        <img v-bind:src="`${this.imgUrl}`" onerror="this.onerror=null;
        	this.src='https://www.mintit.co.kr/assets/images/img/price-device-normal.png';">
        <img v-if="noImg" v-bind:src="`${this.imgUrlLogo}`" alt="" style="position: absolute;">
        <dl class="form-list__row">
          <dt class="form-list__key">
            모델명
          </dt>
          <dd>
            <div>{{ ordInfo.ptnmNm }}</div>
          </dd>
        </dl>
      </figure>
      <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          입금시기
        </dt>
        <dd>
          <div v-html="ordInfo.depositMsg">
          </div>
        </dd>
      </dl>
      <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          평가금액
        </dt>
        <dd>
           <div class="underline"><i><span v-html="ordInfo.pymtAmtMsg"></span>원</i></div>
        </dd>
      </dl>
      <dl class="form-list__row form-donation">
          <dt class="form-list__key">
            기부 여부 확인
	          <div class="div-checkedSameName">
	          <DxCheckBox
	              text="기부하기"
	              v-model="checkedDonate"
	              :disabled="isRegDone"
	              @valueChanged="handleDonate"
	            />
	          </div>
          </dt>
          <dd>
            <div class="agrm-form-input-area donate-area">
              <!--dispabled:  dx-state-disabled -->
              <div class="dx-show-invalid-badge dx-textbox dx-texteditor dx-editor-outlined dx-texteditor-empty">
                <div class="dx-texteditor-container">
                  <div class="dx-texteditor-input-container" style="margin-right: 0px;">
                    <input autocomplete="off" class="dx-texteditor-input" type="text"  v-bind:disabled="isRegDone || !checkedDonate"
                    spellcheck="false" tabindex="0" role="textbox" placeholder="1,000원 이상부터 가능해요" v-model="formattedAmount" @input="formatInput" v-on:keyup.delete="formatDel">

                  </div>
                </div>
              </div>
              <button
                  type="button"
                  class="ui-button ui-line-button"
                  v-bind:disabled="isRegDone"
                  @click="donateApply"
                >
                  적용
                </button>
            </div>
            <div class="form-guide-text ic-children">
              평가금액 내에서 원하는 기부 금액을 입력해주세요 <br> 기부하신 금액은 세이브더칠드런을 통해 사용됩니다
            </div>
          </dd>
        </dl>
       <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          최종 판매금액
        </dt>
      </dl>
      
      <article class="inspection-list__result2" style="background-color:transparent; border:1px solid; border-color:#53D9C1; border-top-right-radius: 8px; border-top-left-radius: 8px;">
        <dl class="inspection-list__result-list2" id="amtDiv">
          <dt style="margin-left:4px; font-weight:700; color:#333333;">평가금액</dt>
          <dd style="margin-right:4px; font-weight:700; color:#333333; font-size:16px; line-height:20px"><span v-html="this.formattedProdAmount"></span>원</dd>
          <dt style="margin-left:4px; font-weight:700; color:#B3B3B3;">기부금</dt>
          <dd style="margin-right:4px; font-weight:700; color:#B3B3B3; font-size:16px; line-height:20px"><span v-html="this.mFormattedAmount"></span></dd>
	      <dt v-if="this.spslAmt1 > 0" style="margin-left:4px; font-weight:700; color:#1FBBA4;">{{this.spslCtt1}}</dt>
	      <dd v-if="this.spslAmt1 > 0" style="margin-right:4px; font-weight:700; color:#1FBBA4; font-size:16px; line-height:20px"><span>{{this.formatSpslAmt1}}</span></dd>
	      <dt v-if="this.spslAmt2 > 0" style="margin-left:4px; font-weight:700; color:#1FBBA4;">{{this.spslCtt2}}</dt>
	      <dd v-if="this.spslAmt2 > 0" style="margin-right:4px; font-weight:700; color:#1FBBA4; font-size:16px; line-height:20px"><span>{{this.formatSpslAmt2}}</span></dd>
	      <dt v-if="this.spslAmt3 > 0" style="margin-left:4px; font-weight:700; color:#1FBBA4;">{{this.spslCtt3}}</dt>
	      <dd v-if="this.spslAmt3 > 0" style="margin-right:4px; font-weight:700; color:#1FBBA4; font-size:16px; line-height:20px"><span>{{this.formatSpslAmt3}}</span></dd>
	      <dt v-if="this.spslAmt4 > 0" style="margin-left:4px; font-weight:700; color:#1FBBA4;">{{this.spslCtt4}}</dt>
	      <dd v-if="this.spslAmt4 > 0" style="margin-right:4px; font-weight:700; color:#1FBBA4; font-size:16px; line-height:20px"><span>{{this.formatSpslAmt4}}</span></dd>
	      <dt v-if="this.spslAmt5 > 0" style="margin-left:4px; font-weight:700; color:#1FBBA4;">{{this.spslCtt5}}</dt>
	      <dd v-if="this.spslAmt5 > 0" style="margin-right:4px; font-weight:700; color:#1FBBA4; font-size:16px; line-height:20px"><span>{{this.formatSpslAmt5}}</span></dd>
      	  <dt v-if="eventAmtVal > 0" style="margin-left:4px; font-weight:700; color:#1FBBA4;">럭키 민팃 이벤트</dt>
          <dd v-if="eventAmtVal > 0" style="margin-right:4px; font-weight:700; color:#1FBBA4; font-size:16px; line-height:20px"><span v-html="this.formattedEventAmount"></span></dd> 
          <dt style="border-top:1px dashed; border-top-color:#F0F0F0; margin-top:12px; margin-bottom:-12px;"></dt>
          <dd style="border-top:1px dashed; border-top-color:#F0F0F0; margin-top:12px; margin-bottom:-12px;"></dd>
      	  <dt style="margin-left:4px; font-weight:700; color:#000000;">최종 판매금액</dt>
          <dd style="margin-right:4px; font-weight:800; color:#000000; font-size:18px; line-height:20px">
          		<span v-html="this.formattedTotAmount" style="background: linear-gradient(to top, #73eed8 27%, transparent 27%);"></span></dd></dd>
        </dl> 
    </article>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import defaultImg from '@/assets/images/phone.svg'
import { DxCheckBox } from 'devextreme-vue/check-box'

export default {
  name: 'PrchModlInfo',
  components: {
    DxCheckBox,
  	defaultImg
  },
  props: ['ordInfo', 'isRegDone','eventAmt'],
  data: () => ({
    	dntnAmt: 0, // 실제 숫자 값을 저장할 변수
    	formattedAmount: '', // 화면에 표시할 형식의 변수
    	allAmt: '',
    	prodAmt: 0,
    	formattedProdAmount: '',
    	formattedTotAmount:'',
    	mFormattedAmount:0,
    	formattedSpslAmt:0,
    	imgUrl: '',
    	imgUrlLogo: '',
    	noImg: false,
    	checkedDonate: false,
    	spslAmt1:0,
    	spslAmt2:0,
    	spslAmt3:0,
    	spslAmt4:0,
    	spslAmt5:0,
    	spslCtt1:0,
    	spslCtt2:0,
    	spslCtt3:0,
    	spslCtt4:0,
    	spslCtt5:0,
    	formatSpslAmt1:'',
    	formatSpslAmt2:'',
    	formatSpslAmt3:'',
    	formatSpslAmt4:'',
    	formatSpslAmt5:'',
  }),
  computed: {
    isPrePaymentOrder () {
      return this.ordInfo.corporationCode === '020200'
    },
    pymtAmtMsg () {
      return this.ordInfo.pymtAmtMsg
    },
    dntnAmtMsg () {
      return this.ordInfo.partDntnAmt
    },
    orderModel () {
      return this.ordInfo.orderModel
    },
    cate02 () {
    	return this.ordInfo.cate02Num
    },
    spslAmts () {
    	return this.ordInfo.payAddCmpAmts.split(",")
    },
    spslCtts () {
    	return this.ordInfo.payAddCmpCtts.split(",")
    },
    spslAmt() {
    	return (parseFloat(this.ordInfo.payAddCmpAmt.replace(/,/g, '')) || 0)
    },
    eventAmtVal() {
    	return (parseFloat(this.ordInfo.eventAmt.replace(/,/g, '')) || 0)
    },
    formattedEventAmount() {
    	this.formattedTotAmount = (this.allAmt - this.dntnAmt + this.spslAmt+this.eventAmtVal).toLocaleString('en-US')+'원'
    	return '+' + this.eventAmtVal.toLocaleString('en-US') + '원'
    }
  },
  created () {
    var img = 'https://d11o63lgw0n6wa.cloudfront.net/images/model/' + this.orderModel + '.png'
    this.imgUrl = img
  },
  mounted () {
  	this.formattedSpslAmt = this.spslAmt == 0 ? '+0원' : '+'+this.spslAmt.toLocaleString('en-US')+'원'
    this.allAmt = parseFloat(this.pymtAmtMsg.replace(/,/g, '')) || 0
    this.prodAmt = parseFloat(this.pymtAmtMsg.replace(/,/g, '')) || 0
    this.formattedAmount = this.dntnAmtMsg.toLocaleString('en-US')
    this.mFormattedAmount = '-'+this.formattedAmount+'원'
    this.formattedAmount = this.formattedAmount == 0 ? '' : this.formattedAmount + '원' 
    this.formattedProdAmount = (this.allAmt - this.dntnAmtMsg).toLocaleString('en-US')
    this.formattedTotAmount = (this.allAmt - this.dntnAmtMsg+this.spslAmt+this.eventAmtVal).toLocaleString('en-US')+'원'
    const spslAmtArr = this.spslAmts
    const spslCttArr = this.spslCtts
    
    for (var i = 0; i < spslAmtArr.length; i++) {
	  if(i == 0) {
	  	this.spslAmt1 = parseFloat(spslAmtArr[i])
	  	this.formatSpslAmt1 = '+' + this.spslAmt1.toLocaleString('en-US') + '원'
	  	this.spslCtt1 = spslCttArr[i].toLocaleString('en-US')
	  }else if(i == 1) {
	  	this.spslAmt2 = parseFloat(spslAmtArr[i])
	  	this.formatSpslAmt2 = '+' + this.spslAmt2.toLocaleString('en-US') + '원'
	  	this.spslCtt2 = spslCttArr[i]
	  } else if(i == 2) {
	  	this.spslAmt3 = parseFloat(spslAmtArr[i])
	  	this.formatSpslAmt3 = '+' + this.spslAmt3.toLocaleString('en-US') + '원'
	  	this.spslCtt3 = spslCttArr[i]
	  } else if(i == 3) {
	  	this.spslAmt4 = parseFloat(spslAmtArr[i])
	  	this.formatSpslAmt4 = '+' + this.spslAmt4.toLocaleString('en-US') + '원'
	  	this.spslCtt4 = spslCttArr[i]
	  } else if(i == 4) {
	  	this.spslAmt5 = parseFloat(spslAmtArr[i])
	  	this.formatSpslAmt5 = '+' + this.spslAmt5.toLocaleString('en-US') + '원'
	  	this.spslCtt5 = spslCttArr[i]
	  }  
	} 
  },
  watch: {
	ordInfo (newVal, oldVal) {
		console.log(newVal)
		console.log(oldVal)
	}
  },
  methods: {
    donateApply (e) {
	    if ((this.dntnAmt).toString().slice(-3) !== '000' && this.dntnAmt != 0) {
	        this.$Alert.alert('기부는 천원 단위로 가능합니다')
	    	return
	    }
      if (this.dntnAmt == 0) {
        this.$emit('changeDonate', {isDonate: false, dntnAmt: this.dntnAmt})
      } else {
        this.$emit('changeDonate', {isDonate: true, dntnAmt: this.dntnAmt})
      }
      if (this.dntnAmt == this.allAmt) {
        this.$emit('changeAllDonate', {isAllDonate: true, dntnAmt: this.dntnAmt})
      } else {
        this.$emit('changeAllDonate', {isAllDonate: false, dntnAmt: this.dntnAmt})
      }
      window.scrollTo(0, e.pageY + 100)
    },
    formatInput () {	
      // 입력된 값을 숫자로 파싱하고 천 단위 콤마 추가
      const removeAmount = this.formattedAmount.replace('원', '')
      const parsedAmount = parseFloat(removeAmount.replace(/,/g, '')) || 0
      if (this.allAmt < parsedAmount) {
      	this.dntnAmt = this.allAmt
      	this.prodAmt = 0
      	this.formattedAmount = this.dntnAmt.toLocaleString('en-US') + '원'
      	this.formattedTotAmount = (this.prodAmt+this.spslAmt+this.eventAmtVal).toLocaleString('en-US')+'원'
      } else {
      	this.dntnAmt = parsedAmount
      	this.prodAmt = this.allAmt - this.dntnAmt
      	this.formattedAmount = parsedAmount.toLocaleString('en-US')
      	this.formattedAmount = this.formattedAmount == 0 ? '' : this.formattedAmount + '원'
      	this.formattedTotAmount = (this.prodAmt+this.spslAmt+this.eventAmtVal).toLocaleString('en-US')+'원'
      }
      this.mFormattedAmount = '-'+this.formattedAmount
    },
    formatDel () {
      	var removeAmount = this.formattedAmount.replace('원', '')
      	var parsedAmount = removeAmount.substring(0, removeAmount.length - 1)
      	parsedAmount = parseFloat(parsedAmount.replace(/,/g, '')) || 0
      	this.dntnAmt = parsedAmount
      	this.prodAmt = this.allAmt - this.dntnAmt
      	this.formattedAmount = parsedAmount.toLocaleString('en-US')
      	this.formattedAmount = this.formattedAmount == 0 ? '' : this.formattedAmount + '원'
      	this.formattedTotAmount = (this.prodAmt+this.spslAmt+this.eventAmtVal).toLocaleString('en-US')+'원'
      	this.mFormattedAmount = '-'+(this.formattedAmount == 0 ? '0원' : this.formattedAmount)
    },
    handleDonate (e) {
      	  const { value, event } = e
	      if (!value) {
	      		this.formattedAmount = ''
	      		this.prodAmt = this.allAmt
	      		this.dntnAmt = 0
	      		this.formattedProdAmount = this.allAmt.toLocaleString('en-US')
	      		this.mFormattedAmount = '-0원'
	      		if (this.dntnAmt == 0) {
          this.$emit('changeDonate', {isDonate: false, dntnAmt: this.dntnAmt})
        } else {
          this.$emit('changeDonate', {isDonate: true, dntnAmt: this.dntnAmt})
        }
        if (this.dntnAmt == this.allAmt) {
          this.$emit('changeAllDonate', {isAllDonate: true, dntnAmt: this.dntnAmt})
        } else {
          this.$emit('changeAllDonate', {isAllDonate: false, dntnAmt: this.dntnAmt})
        }
	      }
    }
  }
}
</script>
<style>
	.dx-texteditor-input {
		font-size:16px !important;
	}
	.form-section .donate-area div {
		margin-right:12px;
	}
	input[disabled] {
		background: none repeat scroll 0 0 #f8f8f8;
	}
</style>



// WEBPACK FOOTER //
// src/views/purchase/sale/components/NewPrchModlInfo.vue